import React, {Fragment} from 'react';
import {Box, Button, Stack, TextField} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import axios from "axios";
import {FormDialog, toast} from "@lb/mlib-components";
import * as yup from 'yup';
import {Formik} from 'formik';
import dayjs from 'dayjs';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';

const formId = 'add-holiday-form';

const validationSchema = yup.object({
            holiday: yup.date().required('Holiday is required'),
            title: yup.string('Enter title').min(1, 'Title should be of minimum 1 character long')
                .required('Title is required'),
        }
    )
;

export default function AddHoliday(props) {

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        props.handleClose();
    };
    const handleOpen = () => setOpen(true);

    const initialValues = {
        title: '',
        holiday: '',

    }

    const [openBackdrop, setOpenBackdrop] = React.useState(false);

    return (
        <Fragment>
            <Button color="primary" variant={'contained'} startIcon={<AddIcon/>} onClick={handleOpen}>
                Add Holiday
            </Button>
            <FormDialog
                title="Add Holiday"
                open={open}
                onClose={handleClose}
                active={openBackdrop}
                actions={
                    <Button variant="contained" type="submit" form={formId} startIcon={<SaveIcon/>}>
                        Save
                    </Button>
                }
            >
                <Formik enableReinitialize
                        initialValues={initialValues} validationSchema={validationSchema}

                        onSubmit={(values) => {
                            setOpenBackdrop(true);

                            let data = {
                                    holiday: values.holiday,
                                    title: values.title,

                                }
                            ;

                            axios.post('/holidays',
                                data).then(() => {

                                toast.success('Your request has been successfully sent.');

                                handleClose();



                            }).finally(() => {
                                setOpenBackdrop(false);
                            });


                        }}
                >
                    {props => (
                        <Box component="form" id={formId} onSubmit={props.handleSubmit}>
                            <Stack spacing={2} direction="column">
                                <DatePicker
                                    label="Holiday"
                                    sx={{width: '100%'}}
                                    slotProps={{
                                        textField: {
                                            id: 'holiday',
                                            error: props.touched.holiday && Boolean(props.errors.holiday),
                                            helperText: props.touched.holiday && props.errors.holiday,
                                        },
                                    }}
                                    value={props.values.holiday ? dayjs(props.values.holiday) : null}
                                    onChange={(newValue) => props.setFieldValue('holiday', newValue ? newValue.format('YYYY-MM-DD') : '')}
                                />
                                <TextField
                                    title="title"
                                    fullWidth
                                    id="title"
                                    name="title"
                                    label="Title"
                                    autoFocus
                                    value={props.values.title}
                                    onChange={props.handleChange}
                                    error={props.touched.title && Boolean(props.errors.title)}
                                    helperText={props.touched.title && props.errors.title}
                                />
                            </Stack>
                        </Box>
                    )}

                </Formik>
            </FormDialog>
        </Fragment>
    );
};
